__turbopack_context__.v({
  "stageCard": "ElectionTimeline-module__nYzSzq__stageCard",
  "stageIcon": "ElectionTimeline-module__nYzSzq__stageIcon",
  "stageIconWrap": "ElectionTimeline-module__nYzSzq__stageIconWrap",
  "stageIndex": "ElectionTimeline-module__nYzSzq__stageIndex",
  "stageText": "ElectionTimeline-module__nYzSzq__stageText",
  "stageTitle": "ElectionTimeline-module__nYzSzq__stageTitle",
  "timelineSection": "ElectionTimeline-module__nYzSzq__timelineSection",
  "timelineTrack": "ElectionTimeline-module__nYzSzq__timelineTrack",
  "trackLine": "ElectionTimeline-module__nYzSzq__trackLine",
});
